/*
  ARS — Brinde automático (abanico surpresa).

  Este arquivo era o painel de escolha do modelo. Na ação atual a cliente NÃO
  escolhe: o abanico é surpresa, sorteado pela Maria na hora de embalar. O
  Shopify só precisa saber que um abanico foi concedido — qual, ele não sabe.

  Faz três coisas, e só estas três:
    1. cruzou o mínimo e não tem abanico → adiciona sozinho
    2. caiu abaixo do mínimo com abanico → tira sozinho
    3. ela removeu o abanico na mão      → entende como recusa e não devolve

  O item 2 é o mais importante do arquivo. Sem escolha, ela nunca decidiu
  COMPRAR o abanico. Se o carrinho cai abaixo do mínimo o desconto para de
  valer e a linha volta a custar R$ 129 — seria cobrar por algo que ninguém
  pediu. Por isso a remoção é automática e silenciosa.

  O item 3 existe porque adicionar sem perguntar cria a obrigação de aceitar
  o "não, obrigada". A recusa vive em sessionStorage e vale enquanto o
  carrinho seguir acima do mínimo. Se ela descer e subir de novo, é convite
  novo — o carrinho mudou, a decisão pode mudar junto.

  A conta do mínimo é a MESMA da barra e a MESMA do desconto no admin: soma
  tudo que não é o produto-brinde. Mudou em um lugar, muda nos três, senão o
  carrinho promete e o checkout cobra.

  BUG CORRIGIDO (10/09): a remoção automática ficava presa ao aviso
  PUB_SUB_EVENTS.cartUpdate — e este tema tem TRÊS caminhos diferentes que
  mudam o carrinho (carrinho deslizante, /cart personalizada pela Lind, e
  remoção de kits), cada um avisando o resto da página do seu jeito. Se esse
  aviso não disparasse (ordem de carregamento dos scripts, por exemplo), o
  script nunca ficava sabendo que algo saiu do carrinho, e o abanico ficava
  esquecido lá dentro cobrando o preço cheio. Agora o script observa
  diretamente toda chamada a /cart/add, /cart/change e /cart/update — não
  importa quem a fez — e reage sozinho, sem depender de ninguém avisar.
  O aviso antigo continua como reforço, com nova tentativa de conexão caso
  não esteja pronto no primeiro segundo.

  UX AJUSTADA (10/09): o botão "Adicionar meu abanico" nasce ESCONDIDO no
  HTML (snippets/cart-drawer-shipping-bar.liquid). Antes ele aparecia sempre
  que o carrinho cruzava o mínimo e piscava na tela por uma fração de
  segundo até o automático terminar — quebrava a surpresa, parecia que a
  ação exigia um clique quando na verdade não exige. Agora só este arquivo
  decide reexibi-lo, e só em duas situações genuínas: ela recusou antes (o
  automático sabidamente não vai rodar) ou o automático tentou e não
  completou a tempo (rede lenta, falha). No caminho normal — a grande
  maioria — ele nunca chega a aparecer.

  O nome do arquivo continua ars-gift-picker.js de propósito: ele já é
  chamado por snippets/cart-drawer.liquid e por sections/ars-cart-gift.liquid.
  Renomear obrigaria a mexer nos dois sem ganho nenhum.
*/

(function () {
  var REFUSED_KEY = 'ars-gift-refused';
  var OWN_REQUEST_HEADER = 'X-Ars-Gift-Sync';
  var RESCUE_DELAY_MS = 1500;
  var busy = false;
  var lastGiftInCart = null;

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function trimSlash(path) {
    if (path.length > 1 && path.charAt(path.length - 1) === '/') return path.slice(0, -1);
    return path;
  }

  function isCartPage() {
    return trimSlash(window.location.pathname) === trimSlash(route('cart_url', '/cart'));
  }

  /* O bloco de config é escrito pela barra de progresso e só existe quando o
     brinde está ligado (produto definido, mínimo definido, estoque de pé).
     A ausência dele é o desligamento da ação, não um erro — quando os
     abanicos acabarem, tudo aqui simplesmente para de agir. */
  function config() {
    var el = document.querySelector('[data-ars-gift-config]');
    if (!el) return null;
    var cfg = {
      productId: Number(el.dataset.giftProductId || 0),
      variantId: Number(el.dataset.giftVariantId || 0),
      threshold: Number(el.dataset.giftThreshold || 0)
    };
    if (!cfg.productId || !cfg.threshold) return null;
    return cfg;
  }

  /* Tira o "hidden" do botão de resgate manual, se ele existir no DOM neste
     momento. Buscamos fresco a cada chamada (nunca guardamos a referência)
     porque o elemento é substituído inteiro sempre que o carrinho
     re-renderiza — uma referência antiga viraria um nó órfão. */
  function revealRescueButton() {
    var btn = document.querySelector('[data-ars-gift-add]');
    if (btn) btn.hidden = false;
  }

  /* Marca as PRÓPRIAS chamadas com um header, para o vigia de fetch (mais
     abaixo) saber que não precisa reagir a elas — senão cada remoção do
     brinde disparava uma nova sincronização dele mesmo, em looping. */
  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-Ars-Gift-Sync': '1'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json();
    });
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsPayload() {
    var el = drawer();
    if (!el || typeof el.getSectionsToRender !== 'function') return null;
    return el.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  /* O Dawn ABRE o carrinho deslizante dentro do renderContents. Aqui isso
     seria um susto: a cliente está numa página de produto, o brinde entra
     sozinho e o carrinho salta na tela sem ela ter pedido nada. Por isso
     renderContents só quando o drawer JÁ está aberto; fechado, trocamos o
     HTML das mesmas seções na mão, em silêncio. */
  function repaint(data) {
    if (isCartPage()) {
      window.location.reload();
      return;
    }

    var el = drawer();
    if (!el || !data || !data.sections) return;

    if (el.classList.contains('active') && typeof el.renderContents === 'function') {
      el.classList.remove('is-empty');
      el.renderContents(data);
    } else if (typeof el.getSectionsToRender === 'function') {
      el.getSectionsToRender().forEach(function (section) {
        var selector = section.selector || '.shopify-section';
        var target = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        var raw = data.sections[section.id];
        if (!target || !raw) return;
        var parsed = new DOMParser().parseFromString(raw, 'text/html');
        var source = parsed.querySelector(selector);
        if (source) target.innerHTML = source.innerHTML;
      });
      el.classList.remove('is-empty');
    }

    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ars-gift', cartData: data });
    }
  }

  function withSections(payload) {
    if (isCartPage()) return payload;
    var sections = sectionsPayload();
    if (sections) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    return payload;
  }

  function addGift(cfg) {
    return post(route('cart_add_url', '/cart/add.js'), withSections({
      items: [{ id: cfg.variantId, quantity: 1 }]
    })).then(function (data) {
      if (data && data.status) throw new Error(data.description || 'não foi possível adicionar o brinde');
      lastGiftInCart = true;
      repaint(data);
    });
  }

  function removeGift(key) {
    return post(route('cart_change_url', '/cart/change.js'), withSections({
      id: key,
      quantity: 0
    })).then(function (data) {
      lastGiftInCart = false;
      repaint(data);
    });
  }

  function sync() {
    if (busy) return Promise.resolve();
    var cfg = config();
    if (!cfg) return Promise.resolve();

    busy = true;

    return fetch(route('cart_url', '/cart') + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var qualifying = 0;
        var giftLine = null;

        (cart.items || []).forEach(function (item) {
          if (item.product_id === cfg.productId) {
            giftLine = item;
          } else {
            qualifying += item.final_line_price;
          }
        });

        if (qualifying < cfg.threshold) {
          /* Caiu abaixo: episódio encerrado. Limpar a recusa aqui é de
             propósito — se ela voltar a passar do mínimo, é um carrinho
             diferente e merece um convite novo. */
          sessionStorage.removeItem(REFUSED_KEY);
          if (giftLine) return removeGift(giftLine.key);
          lastGiftInCart = false;
          return null;
        }

        if (giftLine) {
          lastGiftInCart = true;
          return null;
        }

        if (sessionStorage.getItem(REFUSED_KEY)) {
          /* Ela recusou antes e o carrinho segue acima do mínimo: o
             automático sabidamente NUNCA vai rodar aqui (é assim que a
             recusa funciona). Então o botão de resgate é a única porta de
             volta — mostra na hora, sem esperar nada. */
          revealRescueButton();
          return null;
        }

        /* Estava no carrinho no ciclo anterior, sumiu, e o mínimo continua de
           pé: só pode ter sido ela quem tirou. Isso é o "não, obrigada". */
        if (lastGiftInCart === true) {
          sessionStorage.setItem(REFUSED_KEY, '1');
          lastGiftInCart = false;
          revealRescueButton();
          return null;
        }

        if (!cfg.variantId) return null;

        /* Caminho normal: vamos tentar adicionar sozinho. O botão continua
           escondido — só aparece se, passada uma folga curta, o automático
           ainda não tiver terminado (rede lenta, falha silenciosa). Se der
           certo antes disso, o carrinho inteiro é re-renderizado e este
           temporizador não encontra mais botão nenhum escondido pra mexer. */
        window.setTimeout(revealRescueButton, RESCUE_DELAY_MS);
        return addGift(cfg);
      })
      .catch(function (error) {
        console.error('[ars-gift]', error);
        revealRescueButton();
      })
      .finally(function () {
        busy = false;
      });
  }

  /* VIGIA DE FETCH — a correção do bug de 10/09.

     Em vez de confiar só no aviso PUB_SUB_EVENTS.cartUpdate (que depende de
     cada trecho do tema lembrar de publicá-lo, e nem todos os caminhos que
     mudam o carrinho passam por ele), passamos a observar toda chamada a
     /cart/add, /cart/change e /cart/update — é a única porta pela qual o
     carrinho muda, então observar aqui cobre qualquer código, presente ou
     futuro, que mexa nele. Ignoramos as PRÓPRIAS chamadas (marcadas pelo
     header X-Ars-Gift-Sync) para não entrar em looping. */
  function isCartMutationUrl(url) {
    if (!url) return false;
    var path = String(url).split('?')[0];
    return (
      path.indexOf('/cart/add') !== -1 ||
      path.indexOf('/cart/change') !== -1 ||
      path.indexOf('/cart/update') !== -1
    );
  }

  function installFetchWatcher() {
    if (window.__arsGiftFetchPatched || typeof window.fetch !== 'function') return;
    window.__arsGiftFetchPatched = true;

    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var headers = (init && init.headers) || {};
      var isOwn = !!(headers[OWN_REQUEST_HEADER] || (typeof headers.get === 'function' && headers.get(OWN_REQUEST_HEADER)));
      var isMutation = !isOwn && isCartMutationUrl(url);

      var request = originalFetch(input, init);

      if (isMutation) {
        request.then(function () {
          /* pequeno atraso para deixar quem chamou terminar o próprio repaint
             antes da gente ler o carrinho de novo */
          window.setTimeout(sync, 150);
        }).catch(function () {});
      }

      return request;
    };
  }

  /* Resgate manual. O botão só fica visível no estado "passou do mínimo, sem
     abanico, e o automático genuinamente não vai dar conta sozinho" (ver
     revealRescueButton e os dois pontos onde sync() chama ela). Clicar
     limpa a recusa e tenta de novo. */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('[data-ars-gift-add]');
    if (!btn) return;
    event.preventDefault();
    sessionStorage.removeItem(REFUSED_KEY);
    lastGiftInCart = null;
    btn.disabled = true;
    sync().then(function () {
      btn.disabled = false;
    });
  });

  /* Reforço do aviso antigo: se subscribe/PUB_SUB_EVENTS ainda não
     existirem quando este script rodar (ordem de carregamento), tenta de
     novo por alguns segundos em vez de desistir na primeira checagem. O
     vigia de fetch acima já cobre o essencial de qualquer forma — isto é
     só um reforço mais rápido quando o aviso funciona. */
  function bindPubSub(attempt) {
    attempt = attempt || 0;
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'ars-gift') return;
        sync();
      });
      return;
    }
    if (attempt >= 20) return;
    window.setTimeout(function () {
      bindPubSub(attempt + 1);
    }, 200);
  }

  function start() {
    installFetchWatcher();
    sync();
    bindPubSub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
